import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_byf8uyy27h: FaireBrandEntity = {
  token: "b_byf8uyy27h",
  type: "brand",
  name: "My Neighbor’s",
  avatarUrl:
    "https://cdn.faire.com/fastly/df8e031fbf53dd846d7f25d6e7246850b2c9c683e6fb3717d0699c208d697e2f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/537aecf2f82c30c5030dca0ac4b7067e7f704f9b8a0630686bfbc161618946c9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/df8e031fbf53dd846d7f25d6e7246850b2c9c683e6fb3717d0699c208d697e2f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/537aecf2f82c30c5030dca0ac4b7067e7f704f9b8a0630686bfbc161618946c9.jpeg",
  location: "Hudson, NY, USA",
  minimumOrderDollars: 205,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "My Neighbor’s was born from a desire to create uncompromisingly natural skincare—made by hand, powered by local agriculture, and rooted in regenerative practices.\n\nAfter leaving a fast-paced Wall Street career to start a family in the Hudson Valley, I was searching for a safe, effective solution for my newborn daughter’s eczema. Disheartened by the synthetic, chemical-laden options on store shelves, I turned to my local farming community—and found my answer at Kinderhook Farm, where I learned to render 100% grass-fed and finished tallow and fell in love with regenerative agriculture.\n\nWhat began as a simple balm in my kitchen has grown into a skincare line made in partnership with over 12 regenerative farms in the Hudson Valley. We now formulate tallow- and plant-based products in small batches using nutrient-rich ingredients that are safe enough for babies, effective enough for grown-ups, and versatile enough for every skin type in the family.\n\nToday, My Neighbor’s is carried in over 250+ stores—from local cafés and boutiques to national retailers like Terrain and Backcountry. Each product is designed to nourish the skin while honoring the land it came from—because we believe skincare should heal, both people and the planet.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:02.195Z",
    importedBy: "entity-db-cli",
  },
};
